import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  onClose: () => void;
}
export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  onClose
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  // Close on escape key press
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);
  // Handle click outside to close
  const handleOutsideClick = (e: React.MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={handleOutsideClick} data-id="element-156">
      <div ref={modalRef} className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-157">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-between items-center" data-id="element-158">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-159">Privacy Policy</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Close privacy policy" data-id="element-160">
            <XIcon size={24} data-id="element-161" />
          </button>
        </div>
        <div className="p-6" data-id="element-162">
          <div className="prose max-w-none" data-id="element-163">
            <h3 data-id="element-164">Introduction</h3>
            <p data-id="element-165">
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you visit our website or purchase
              our book "Charlie Kirk: Life, Quotes & Legacy." Please read this
              privacy policy carefully. By accessing or using our services, you
              acknowledge that you have read, understood, and agree to be bound
              by all the terms outlined in this privacy policy.
            </p>
            <h3 data-id="element-166">Information We Collect</h3>
            <p data-id="element-167">
              <strong data-id="element-168">Personal Data:</strong> We may collect personal
              identification information, including but not limited to your
              name, email address, mailing address, phone number, and payment
              information when you purchase our book or sign up for our
              newsletter.
            </p>
            <p data-id="element-169">
              <strong data-id="element-170">Usage Data:</strong> We may also collect information on
              how the website is accessed and used. This data may include your
              computer's IP address, browser type, browser version, pages
              visited, time spent on those pages, and other diagnostic data.
            </p>
            <h3 data-id="element-171">How We Use Your Information</h3>
            <ul data-id="element-172">
              <li data-id="element-173">To process and fulfill your book order</li>
              <li data-id="element-174">To provide customer support</li>
              <li data-id="element-175">
                To send you promotional materials and newsletters (if you've
                opted in)
              </li>
              <li data-id="element-176">To improve our website and services</li>
              <li data-id="element-177">To comply with legal obligations</li>
            </ul>
            <h3 data-id="element-178">Disclosure of Your Information</h3>
            <p data-id="element-179">
              We may share your information with third parties only in the ways
              described in this privacy policy, including:
            </p>
            <ul data-id="element-180">
              <li data-id="element-181">
                With service providers who assist us in operating our website
                and conducting our business
              </li>
              <li data-id="element-182">
                To comply with legal requirements, such as a law, regulation,
                court order, or subpoena
              </li>
              <li data-id="element-183">To protect our rights, privacy, safety, or property</li>
            </ul>
            <h3 data-id="element-184">Cookies and Tracking Technologies</h3>
            <p data-id="element-185">
              We use cookies and similar tracking technologies to track activity
              on our website and store certain information. You can instruct
              your browser to refuse all cookies or to indicate when a cookie is
              being sent.
            </p>
            <h3 data-id="element-186">Your Rights</h3>
            <p data-id="element-187">
              Depending on your location, you may have certain rights regarding
              your personal information, including:
            </p>
            <ul data-id="element-188">
              <li data-id="element-189">The right to access information we have about you</li>
              <li data-id="element-190">The right to correct any inaccurate information</li>
              <li data-id="element-191">
                The right to request deletion of your personal information
              </li>
              <li data-id="element-192">The right to opt-out of marketing communications</li>
            </ul>
            <h3 data-id="element-193">Security of Your Information</h3>
            <p data-id="element-194">
              We use administrative, technical, and physical security measures
              to protect your personal information. However, no method of
              transmission over the Internet or electronic storage is 100%
              secure, so we cannot guarantee absolute security.
            </p>
            <h3 data-id="element-195">Changes to This Privacy Policy</h3>
            <p data-id="element-196">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page
              and updating the "Last Updated" date.
            </p>
            <h3 data-id="element-197">Contact Us</h3>
            <p data-id="element-198">
              If you have any questions about this Privacy Policy, please
              contact us at privacy@charliekirkbook.com.
            </p>
            <p className="text-sm text-gray-500 mt-6" data-id="element-199">
              Last Updated: September 2025
            </p>
          </div>
        </div>
      </div>
    </div>;
};